export default __webpack_public_path__ + "static/media/circle.52174c49.png";